import "core-js/modules/es.array.push.js";
import axios from "axios";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      classList: [],
      selectedClassIndexs: [],
      classNames: [],
      showPublishClassCourseConfirm: false
    };
  },
  async mounted() {
    // 获取班级列表
    await this.getClassList();
  },
  methods: {
    // 获取班级列表
    async getClassList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
          }
          console.log("获取班级列表 this.classList:", this.classList);
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //点击班级名，也可选择班级
    clickClassName(index) {
      // 如果已经选中的班级名，再次点击就是取消选中
      if (this.selectedClassIndexs.includes(index)) {
        this.selectedClassIndexs.splice(this.selectedClassIndexs.indexOf(index), 1);
      }
      // 选中
      else {
        this.selectedClassIndexs.push(index);
      }
    },
    publishClassCourse() {
      this.showPublishClassCourseConfirm = true;
    },
    async publishClassCourseConfirm() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let classIds = [];
        for (let i = 0; i < this.selectedClassIndexs.length; i++) {
          classIds.push(this.classList[this.selectedClassIndexs[i]].id);
        }
        let params = {
          classIds: classIds
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/publishCourse/publish", params);
        if (resp1.data.code == "0000") {
          // 不用调用后端更新
          for (let i = 0; i < this.selectedClassIndexs.length; i++) {
            this.classList[this.selectedClassIndexs[i]].status = 2;
          }
          this.selectedClassIndexs = [];
          this.showPublishClassCourseConfirm = false;
        } else {
          console.log("调用publishCourse出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("调用后端出错:", error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    publishClassCourseCancel() {
      this.showPublishClassCourseConfirm = false;
    }
  }
};